//the default react app
import React from 'react';
import Messages from './Messages.js';

function App() {
  return (
    <div>
      <Messages />
    </div>
  );
}

export default App;
